import { Injectable } from '@angular/core';
import { MarcheAPIService } from './api/marche-api.service';
import { ResponseWrapper } from '../@shared/models/response-wrapper.model';

@Injectable({
    providedIn: 'root',
})
export class PageNotFoundService {
    static readonly PAGE_NOT_FOUND = '/404orLegacy';

    constructor(private marcheApiService: MarcheAPIService) {}

    urlRedirection(route: string | undefined) {
        return this.marcheApiService.postRequest<ResponseWrapper<any>>(
            PageNotFoundService.PAGE_NOT_FOUND,
            {},
            { url: route }
        );
    }
}
